import React, { FC } from "react";

import { TNameStatus } from "../../../../state";

import styles from "./Badge.module.scss";

type Props = {
  isArchived: boolean;
  nameStatus: TNameStatus;
};

const Badge: FC<Props> = ({ isArchived, nameStatus }) => {
  return (
    <div className={styles.badgeBlock}>
      {isArchived && <span className={styles.badge}>提出終了</span>}
      {nameStatus === "unpublish" && (
        <span className={styles.badge}>匿名共有</span>
      )}
    </div>
  );
};

export default Badge;
